
















import { Component, Vue } from 'vue-property-decorator';
import Strat from '@/components/Strat.vue';
import RefreshButton from '@/components/RefreshButton.vue';

@Component({
  components: {
    RefreshButton,
    Strat,
  },
})
export default class App extends Vue {
  private strats: string[] = [
    'Pistols Only',
    'SMG Only',
    'DMR Only',
    'Shotgun Only',
    'Shields Only',
    'LMG Only',
    'Hipfire Only',
    'Dropshot Only',
    'Prone(Def Only)',
    'Crouch Only',
    'Burst Mode',
    'One-Tap Mode',
    'Sniper Rifle',
    'One-Bullet Mag',
    'Teamkill',
    'Suicide',
  ];

  private currentStrat = '';
  private status: 'Waiting' | 'Randomizing' | 'Completed' = 'Waiting';

  public randomizeStrat(): void {
    if (this.status !== 'Randomizing') {
      this.status = 'Randomizing';

      const interval = setInterval(() => {
        this.currentStrat = this.getRandomStrat();
      }, 150);

      setTimeout(() => {
        this.status = 'Completed';

        clearInterval(interval);
      }, 5000);
    }
  }

  public resetState(): void {
    this.currentStrat = '';
    this.status = 'Waiting';
  }

  public getRandomStrat(): string {
    const randomIndex = Math.floor(Math.random() * this.strats.length);

    return this.strats[randomIndex];
  }
}
